var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4512 9.72585C19.4512 14.5819 14.0642 19.6392 12.2552 21.2012C12.0867 21.3279 11.8815 21.3964 11.6707 21.3964C11.4598 21.3964 11.2547 21.3279 11.0862 21.2012C9.27718 19.6392 3.89014 14.5819 3.89014 9.72585C3.89014 7.66232 4.70987 5.68331 6.169 4.22418C7.62814 2.76505 9.60714 1.94531 11.6707 1.94531C13.7342 1.94531 15.7132 2.76505 17.1723 4.22418C18.6315 5.68331 19.4512 7.66232 19.4512 9.72585Z",
    stroke: "black",
    strokeWidth: 1.94513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6709 12.6433C13.2823 12.6433 14.5886 11.337 14.5886 9.72556C14.5886 8.11416 13.2823 6.80786 11.6709 6.80786C10.0595 6.80786 8.75317 8.11416 8.75317 9.72556C8.75317 11.337 10.0595 12.6433 11.6709 12.6433Z",
    stroke: "black",
    strokeWidth: 1.94513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.cc0fc6d1891c5897cb87cedc6f60ad47.svg";
export { ForwardRef as ReactComponent };